// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getBlotVerticalSibling = (blot: any, down: boolean): [any, any] => {
  let current = blot;
  const key = down ? 'next' : 'prev';
  while (current && !current[key]) {
    current = current.parent;
  }
  return [current, current?.[key]];
};

export default getBlotVerticalSibling;
